import styled from 'styled-components';

export const Resizer = styled.div`
  background: ${({ theme }) => theme.color.gray[400].value};
  width: 2px;
  margin: 0 12px 0 0;
  cursor: col-resize;
  position: relative;
  &::after {
    content: '';
    top: 50%;
    left: -4px;
    width: 9px;
    height: 25px;
    background: ${({ theme }) => theme.color.gray[400].value};
    position: absolute;
  }
`;
